@use '@design/design-tokens/typography/typography' as *;

@layer chart {
  .ohlcPriceRoot {
    margin-left: 8px;
    display: flex;
    gap: 8px;
    @include typography-v2-body-sm;
  }

  .priceContainer {
    display: flex;
    gap: 8px;
  }

  .label {
    color: var(--text-default);
  }

  .price {
    font-family: var(--font-roboto-mono);
    color: var(--viz-bearish);

    &.bullish {
      color: var(--viz-bullish);
    }
  }
}
